import React from 'react';
import classnames from 'classnames';
import { LOGO_HANDLING_STATUSES } from '../../../redux/logo-editing/logo-editing.constants';
import classes from './logo-upload-progress-bar.scss';
const statuses = {
  [LOGO_HANDLING_STATUSES.UPLOADING_IMAGE]: 'Uploading design',
  [LOGO_HANDLING_STATUSES.SPLITTING_IMAGE_TO_PIXELS]: 'Initiating neural color detection',
  [LOGO_HANDLING_STATUSES.COUNTING_COLORS]: 'Initiating neural color detection',
  [LOGO_HANDLING_STATUSES.EXTRACTING_MEANINGFUL_COLORS]: 'Analyzing color pixels',
  [LOGO_HANDLING_STATUSES.ANALYZING_SHADOW_COLORS]: 'Analyzing color pixels',
  [LOGO_HANDLING_STATUSES.FILTERING_MINOR_COLORS]: 'Analyzing shadow colors',
  [LOGO_HANDLING_STATUSES.PREPARING_PREVIEW]: 'Voila',
  [LOGO_HANDLING_STATUSES.LOADING]: 'Uploading design',
  [LOGO_HANDLING_STATUSES.SUCCESS]: 'Uploaded',
  [LOGO_HANDLING_STATUSES.FINISHED]: 'Almost done'
};
export class LogoUploadProgressBarComponent extends React.Component {
  render() {
    const {
      progress,
      status,
      isSuccess,
      isLimitedEdition
    } = this.props;
    return /*#__PURE__*/React.createElement("div", {
      className: classes.progressBar
    }, /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.progressBarFill, {
        [classes.unknownProgress]: progress === null,
        [classes.close]: status === LOGO_HANDLING_STATUSES.CLOSE,
        [classes.orangeFill]: isLimitedEdition
      }),
      style: {
        width: `${progress}%`
      }
    }), status !== LOGO_HANDLING_STATUSES.CLOSE && /*#__PURE__*/React.createElement("span", {
      className: classes.progressText
    }, statuses[status], !isSuccess && '...'));
  }
}